import { Stack } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import { PdfSectionHeader } from "../components/PdfSectionHeader";
import { PdfTrafficSourcesList } from "../components/PdfTrafficSourcesList";

import { ShareOfChannelTrafficTable } from "./components/share-of-channel-traffic-table/ShareOfChannelTrafficTable";

export const ShareOfChannelTrafficPdf = () => {
    const translate = useTranslation();

    return (
        <Stack gap="24px">
            <PdfSectionHeader
                subtitle={translate("bt.report.channels.share-of-channel-traffic-table.subtitle")}
                title={translate("bt.report.channels.share-of-channel-traffic-table.title")}
            />
            <PdfTrafficSourcesList
                automationIds={{
                    title: "share-of-channel-traffic-pdf-title",
                    body: "share-of-channel-traffic-pdf-body",
                }}
            >
                {(trafficSource) => <ShareOfChannelTrafficTable trafficSource={trafficSource} />}
            </PdfTrafficSourcesList>
        </Stack>
    );
};
